import React from "react"
import { useTranslation } from "react-i18next"
import {
    FloatingLabelInput,
    IFloatingLabelsInputProps,
    TRegister,
    valFuncPattern,
    valFuncRequiredAndPattern,
    validationPatterns,
} from "swiipe.portal.shared"

interface IFullNameInputProps extends IFloatingLabelsInputProps {
    inputName: string
    defaultValue?: string
    isOptional?: boolean
    register: TRegister
}

const FullNameInputComp = ({
    inputName = "fullName",
    defaultValue,
    register,
    isOptional,
    ...otherProps
}: IFullNameInputProps) => {
    const { t } = useTranslation()
    return (
        <FloatingLabelInput
            placeholder={t("common.fullName.label")}
            name={inputName}
            type="text"
            innerRef={
                isOptional
                    ? register(valFuncPattern(validationPatterns.fullName, t("common.fullName.errorMessage")))
                    : register(valFuncRequiredAndPattern(validationPatterns.fullName, t("common.fullName.errorMessage")))
            }
            defaultValue={defaultValue || ""}
            {...otherProps}
        />
    )
}

export default FullNameInputComp
